import { render, staticRenderFns } from "./DiscussionBoardView.vue?vue&type=template&id=1a9d201c&scoped=true&"
import script from "./DiscussionBoardView.vue?vue&type=script&lang=js&"
export * from "./DiscussionBoardView.vue?vue&type=script&lang=js&"
import style0 from "./DiscussionBoardView.vue?vue&type=style&index=0&id=1a9d201c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9d201c",
  null
  
)

export default component.exports